{
    "ComparisonTypeLabel": "Wanneer:",
    "ComparisonTypeOptionNone": "statistisch alarm",
    "ComparisonTypeOptionHigherThan": "Hoger dan",
    "ComparisonTypeOptionHigherEqual": "Hoger\/gelijk",
    "ComparisonTypeOptionLowerThan": "Lager dan",
    "ComparisonTypeOptionLowerEqual": "Lager\/gelijk",
    "ComparisonTypeOptionBetween": "Tussen",
    "ComparisonTypeOptionEqual": "Gelijkwaardig",
    "ComparisonTypeOptionNotEqual": "Niet gelijk",
    "ComparisonTypeOptionNotBetween": "Niet tussen",
    "ComparisonTypeValue": "Waarde:",
    "ComparisonTypeAnd": "En",
    "AlarmTypeLabel": "Type",
    "AlarmTypeNoSound": "[Geen geluid]",
    "AlarmTypeAirRaidSiren": "Air Raid Sirene",
    "AlarmTypeAlarmClock": "Alarmacties",
    "AlarmTypeDing": "Ding",
    "AlarmTypeDoorChime": "Deurbel",
    "AlarmTypeEmergencyServices": "Hulpdiensten",
    "AlarmTypeFastenSeatBelt": "Vastmaken van de veiligheidsgordels",
    "AlarmTypeKerching": "Kerching",
    "AlarmTypePhone": "Telefoon",
    "AlarmTypeQuickBleep": "Snelle bliep",
    "AlarmTypeRadar": "Radar",
    "AlarmTypeSonarPing": "Sonarping",
    "AlarmTypeTarget": "Doelwit",
    "AlarmTypeTing": "Ting",
    "AlarmTypeWarningBeep": "Waarschuwingspiep",
    "AlarmTypeWarningBuzzer": "Waarschuwingszoemer",
    "AlarmRepeatTypeLabel": "Type",
    "AlarmRepeatOnce": "Een keer",
    "AlarmRepeatSeconds": "seconden",
    "AlarmRepeatPersistent": "Aanhoudend",
    "AlarmRepeatRepeat": "Herhalen",
    "AlarmSettingsLabel": "Waarde:",
    "StatisticAlarm_SectionHeader": "statistisch alarm",
    "NAME": "StatisticAlarm",
    "AlarmType_Air Raid Siren": "Sirene luchtaanval",
    "AlarmType_Alarm Clock": "Wekker",
    "AlarmType_Barking": "Blaffen",
    "AlarmType_Birds": "Vogels",
    "AlarmType_Cat": "Kat",
    "AlarmType_Chips": "Chips",
    "AlarmType_Coin Drop": "Munt Drop",
    "AlarmType_Computer": "Computer",
    "AlarmType_Cow": "Koe",
    "AlarmType_Crowd": "Crowd",
    "AlarmType_Dial Tone": "Kiestoon",
    "AlarmType_Ding": "Ding",
    "AlarmType_Dixie Horn": "Dixie Hoorn",
    "AlarmType_Door Chime": "Deurbel",
    "AlarmType_Emergency Services": "Hulpdiensten",
    "AlarmType_Fasten Seat Belt": "Veiligheidsgordel vastmaken",
    "AlarmType_Fire Truck": "Brandweerwagen",
    "AlarmType_Gunshot": "Schotwond",
    "AlarmType_Hammer": "Hamer",
    "AlarmType_Helicopter": "Helikopter",
    "AlarmType_Ice Cubes": "Ijsblokjes",
    "AlarmType_Kerching": "Kerching",
    "AlarmType_Laughter": "Gelach",
    "AlarmType_Marbles": "Knikkers",
    "AlarmType_Monkey": "Aap",
    "AlarmType_Morse Code": "Morsealfabet",
    "AlarmType_Night Time": "Nacht",
    "AlarmType_Owl": "Uil",
    "AlarmType_Phone": "Telefoon",
    "AlarmType_Pool": "Zwembad",
    "AlarmType_Pouring Water": "Water gieten",
    "AlarmType_Quick Bleep": "Snelle pieptoon",
    "AlarmType_Radar": "Radar",
    "AlarmType_Reload": "Herladen",
    "AlarmType_Rocks Falling": "Vallende stenen",
    "AlarmType_Rooster": "Haan",
    "AlarmType_Sawing": "Zagen",
    "AlarmType_School Bell": "Schoolbel",
    "AlarmType_Seaguls": "Zeemeeuwen",
    "AlarmType_Service Bell": "Dienstbel",
    "AlarmType_SMS": "SMS",
    "AlarmType_Sonar Ping": "Sonar Ping",
    "AlarmType_Splash": "Splash",
    "AlarmType_Steam Train": "Stoomtrein",
    "AlarmType_Submarine": "Onderzeeër",
    "AlarmType_Target": "Doel",
    "AlarmType_Thunder": "Donder",
    "AlarmType_Ting": "Ting",
    "AlarmType_Tolling Bell": "Bellen",
    "AlarmType_Trombone": "Trombone",
    "AlarmType_Twinkle": "Twinkle",
    "AlarmType_Walking": "Wandelen",
    "AlarmType_Whistling": "Fluitend",
    "AlarmType_Warning Beep": "Waarschuwingspieptoon",
    "AlarmType_Warning Buzzer": "Waarschuwingszoemer"
}